module.exports = __webpack_public_path__ + "static/media/cj_vip.311f299c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/account/cj_vip.png
// module id = 1932
// module chunks = 4